import { reactive } from 'vue';
import {
    getPlatformTokenParsed,
    initPlatformKeycloak,
    isSkipAuth,
    platformLogin as kcLogin,
    platformLogout as kcLogout,
} from './keycloak-platform.service';

// Platform-admin auth context. Unlike the CPO side, there is no /api/v1/me for
// platform staff (that endpoint is gated on CPO roles), so the profile is
// derived directly from the validated token's claims.

export const state = reactive({
    profile: null,
    isAuthenticated: false,
    isLoggingOut: false,
});

export const getters = {
    get isAuthenticated() {
        return state.isAuthenticated;
    },
    get isLoggingOut() {
        return state.isLoggingOut;
    },
    get profile() {
        return state.profile;
    },
    get roles() {
        return state.profile?.roles || [];
    },
    get isPlatformAdmin() {
        return getters.roles.includes('platform-admin');
    },
    hasRole(role) {
        return getters.roles.includes(role.toLowerCase());
    },
};

function profileFromToken(tokenParsed) {
    return {
        sub: tokenParsed.sub,
        email: tokenParsed.email,
        username: tokenParsed.preferred_username,
        displayName:
            tokenParsed.name ||
            tokenParsed.preferred_username ||
            tokenParsed.email,
        roles: tokenParsed.realm_access?.roles || [],
    };
}

export async function checkPlatformSession() {
    if (isSkipAuth()) {
        state.profile = {
            sub: 'dev-platform-user',
            email: 'platform-admin@hive.local',
            username: 'platform-admin',
            displayName: 'Platform Admin',
            roles: ['platform-admin'],
        };
        state.isAuthenticated = true;

        return state.profile;
    }

    await initPlatformKeycloak();
    const tokenParsed = getPlatformTokenParsed();

    if (!tokenParsed) {
        state.profile = null;
        state.isAuthenticated = false;

        return null;
    }

    state.profile = profileFromToken(tokenParsed);
    state.isAuthenticated = true;

    return state.profile;
}

export function login() {
    return kcLogin();
}

export function logout() {
    state.isLoggingOut = true;

    return kcLogout().catch((err) => {
        state.isLoggingOut = false;
        throw err;
    });
}
